var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tag_name == "a"
    ? _c(
        _vm.tag_name,
        {
          tag: "component",
          staticClass: "btn",
          class: [
            _vm.theme,
            {
              "btn-floating": _vm.float === true
            }
          ],
          attrs: { href: _vm.link(), role: "button" }
        },
        [
          _c("BaseIcon", {
            class: _vm.icon.cls,
            attrs: { content: _vm.icon.content }
          })
        ],
        1
      )
    : _c(
        _vm.tag_name,
        {
          tag: "component",
          staticClass: "btn",
          class: [
            _vm.theme,
            {
              "btn-floating": _vm.float === true
            }
          ],
          attrs: { role: "button" },
          on: {
            click: function($event) {
              _vm.click_event()
            }
          }
        },
        [
          _c("BaseIcon", {
            class: _vm.icon.cls,
            attrs: { content: _vm.icon.content }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40bc48da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40bc48da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/base/BaseIconButton.vue
// module id = 763
// module chunks = 0